import Page from '../../components/Page';
import React from 'react';
import {Button, Form, FormGroup, Input, Label, Col, Row, Card, CardBody, CardHeader} from 'reactstrap';
import {FormBuilder, FieldGroup, FieldControl, Validators,} from "react-reactive-form";
import {Link} from "react-router-dom";
import InputMask from 'react-input-mask';
import API from "../../resources/index";

class CompanyFormPage extends React.Component {
    companyResource = API.companyResource;
    managerResource = API.managerResource;

    constructor() {
        super();
        this.state = {
            company: {},
            managers: [],
        };
    }

    companyForm = FormBuilder.group({
        manager_id: ['', Validators.required],
        social_name: ['', Validators.required],
        cpf_cnpj: ['', Validators.required],
        phone: ['', Validators.required],
        status_payment: ['', Validators.required],
        is_activated: [0]
    });

    getCompany = () => {
        if (this.props.match.params && this.props.match.params.company_id) {
            this.companyResource.fetch(this.props.match.params.company_id, {keys: {expand: ['manager']}})
                .then(response => {
                    if (response.status === 200) {
                        this.setState({company: response.data});
                        for (let control in this.companyForm.controls) {
                            if (response.data[control])
                                this.companyForm.controls[control].setValue(response.data[control]);
                        }
                    }
                });
        }
    };

    componentDidMount() {
        this.managerResource.query({keys: {expand: ['auth']}})
            .then(response => {
                if (response.status === 200) {
                    this.setState({managers: response.data});
                }

                this.getCompany();
            });
    }

    onSubmit = (event) => {
        event.preventDefault();

        if (this.state.company.id) {
            this.companyResource.put(this.state.company.id, this.companyForm.value, {keys: {expand: ['auth']}})
                .then(response => {
                    if (response.status === 200)
                        this.props.history.push(`/companies/detail/${response.data.id}`);
                })
        } else {
            this.companyResource.create(this.companyForm.value)
                .then(response => {
                    if (response.status === 201)
                        this.props.history.push(`/companies/detail/${response.data.id}`);
                })
        }
    };

    render() {
        const {company} = this.state;
        return <Page
            title={(company.id ? 'Editar' : 'Nova') + ' Empresa'}
            icon='MdDomain'
            // breadcrumbs={[
            //     {name: 'Empresas', active: false},
            //     {name: (company.id ? 'Editar' : 'Nova') + ' Empresa', active: true}
            // ]}
            className="">
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader>
                            <Link className='btn btn-outline-secondary mr-2'
                                  to={`/companies`}>
                                Empresas
                            </Link>

                            {company.id &&
                            <Link className='btn btn-outline-secondary mr-2' to={`/companies/detail/${company.id}`}>
                                Ver
                            </Link>}
                        </CardHeader>
                        <CardBody>
                            <FieldGroup
                                control={this.companyForm}
                                render={({get, invalid}) => {
                                    return (
                                        <Form onSubmit={this.onSubmit}>
                                            <FieldControl
                                                name="manager_id"
                                                render={({handler, touched, hasError, meta}) => (
                                                    <FormGroup>
                                                        <Label for="manager_id">Gestor</Label>
                                                        <Input type="select" id="manager_id" {...handler()}>
                                                            <option selected value=''>-- Selecione um Gestor --</option>
                                                            {this.state.managers.map(manager => {
                                                                return <option key={manager.id} value={manager.id}>
                                                                    {manager.name}
                                                                </option>
                                                            })}
                                                        </Input>
                                                        <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                    </FormGroup>
                                                )}
                                                meta={{label: "Gestor"}}
                                            />

                                            <FieldControl
                                                name="social_name"
                                                render={({handler, touched, hasError, meta}) => (
                                                    <FormGroup>
                                                        <Label for="social_name">Razão Social / Nome Fantasia</Label>
                                                        <Input type="text" id="social_name" {...handler()}/>
                                                        <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                    </FormGroup>
                                                )}
                                                meta={{label: "Razão Social / Nome Fantasia"}}
                                            />

                                            <FieldControl
                                                name="cpf_cnpj"
                                                render={({handler, touched, hasError, meta}) => (
                                                    <FormGroup>
                                                        <Label for="cpf_cnpj">CNPJ</Label>
                                                        <InputMask mask="99.999.999/9999-99"
                                                                   className='form-control'
                                                                   type="tel"
                                                                   id="cpf_cnpj"  {...handler()}/>
                                                        <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                    </FormGroup>
                                                )}
                                                meta={{label: "CNPJ"}}
                                            />

                                            <FieldControl
                                                name="phone"
                                                render={({handler, touched, hasError, meta}) => (
                                                    <FormGroup>
                                                        <Label for="phone">Telefone</Label>
                                                        <InputMask mask="(99) 99999-9999"
                                                                   className='form-control'
                                                                   type="tel"
                                                                   id="phone" {...handler()}/>
                                                        <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                    </FormGroup>
                                                )}
                                                meta={{label: "Telefone"}}
                                            />

                                            <FieldControl
                                                name="status_payment"
                                                render={({handler, touched, hasError, meta}) => (
                                                    <FormGroup>
                                                        <Label for="status_payment">Status de Pagamento</Label>
                                                        <Input type="select" id="status_payment" {...handler()}>
                                                            <option value='aguardando pagamento'>
                                                                Aguardando Pagamento
                                                            </option>
                                                            <option value='adimplente'>
                                                                Adimplente
                                                            </option>
                                                            <option value='inadimplente'>
                                                                Inadimplente
                                                            </option>
                                                        </Input>
                                                        <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                    </FormGroup>
                                                )}
                                                meta={{label: "Status de Pagamento"}}
                                            />

                                            <FieldControl
                                                name="due_day"
                                                render={({handler, touched, hasError, meta}) => (
                                                    <FormGroup>
                                                        <Label for="due_day">Dia de pagamento</Label>
                                                        <Input type="number" min='1' max='31'
                                                               id="due_day" {...handler()}/>
                                                        <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                    </FormGroup>
                                                )}
                                                meta={{label: "Dia de pagamento"}}
                                            />

                                            <FieldControl
                                                name="days_to_block"
                                                render={({handler, touched, hasError, meta}) => (
                                                    <FormGroup>
                                                        <Label for="days_to_block">
                                                            Dias para Bloqueio após Vencimento
                                                        </Label>
                                                        <Input type="number" min='0'
                                                               id="days_to_block" {...handler()}/>
                                                        <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                    </FormGroup>
                                                )}
                                                meta={{label: "Dias para bloqueio após vencimento"}}
                                            />

                                            <FieldControl
                                                name="is_activated"
                                                render={({handler, touched, hasError, meta}) => (
                                                    <FormGroup>
                                                        <Label for="is_activated">Status</Label>
                                                        <Input type="select" id="is_activated" {...handler()}>
                                                            <option value={1}>Ativo</option>
                                                            <option value={0}>Inativo</option>
                                                        </Input>
                                                        <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                    </FormGroup>
                                                )}
                                                meta={{label: "Status"}}
                                            />

                                            <FormGroup>
                                                <Button disabled={invalid}>Salvar</Button>
                                            </FormGroup>
                                        </Form>
                                    )
                                }}/>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    };
}

export default CompanyFormPage;



// WEBPACK FOOTER //
// ./src/pages/company/CompanyFormPage.js